export const FETCH_RESOURCE_APPROVAL_REQUEST = 'FETCH_RESOURCE_APPROVAL_REQUEST';
export const FETCH_RESOURCE_APPROVAL_SUCCESS = 'FETCH_RESOURCE_APPROVAL_SUCCESS';
export const FETCH_RESOURCE_APPROVAL_FAILURE = 'FETCH_RESOURCE_APPROVAL_FAILURE';

export const UPDATE_RESOURCE_APPROVAL_REQUEST = 'UPDATE_RESOURCE_APPROVAL_REQUEST';
export const UPDATE_RESOURCE_APPROVAL_SUCCESS = 'UPDATE_RESOURCE_APPROVAL_SUCCESS';
export const UPDATE_RESOURCE_APPROVAL_FAILURE = 'UPDATE_RESOURCE_APPROVAL_FAILURE';

export const FETCH_JOBDETAILS_APPROVAL_REQUEST = 'FETCH_JOBDETAILS_APPROVAL_REQUEST';
export const FETCH_JOBDETAILS_APPROVAL_SUCCESS = 'FETCH_JOBDETAILS_APPROVAL_SUCCESS';
export const FETCH_JOBDETAILS_APPROVAL_FAILURE = 'FETCH_JOBDETAILS_APPROVAL_FAILURE';
